import { useTransactionHistoryContext } from "../../Contexts/TransactionHistoryContext";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DatePicker from "../../Components/DatePicker";
import Button from "../../Components/Button";
import React from "react";
import dayjs from "dayjs";
import {
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Modal,
} from "@mui/material";

export default function Filters() {
  const {
    handleSelectConsultationType,
    handleSelectMedicalTestType,
    handleSelectSpecialization,
    selectedConsultationType,
    selectedMedicalTestType,
    selectedSpecialization,
    transactionStatusList,
    handleSelectTransType,
    handleSelectTimeFrame,
    handleSelectClaimType,
    consultationTypeList,
    handleChangeDateFrom,
    medicalTestTypeList,
    handleSelectStatus,
    specializationList,
    handleChangeDateTo,
    selectedTransType,
    selectedClaimType,
    selectedDateRange,
    hasValidDateRange,
    handleCloseFilter,
    handleApplyFilter,
    handleClearFilter,
    transactionTypes,
    selectedStatus,
    claimTypeList,
    loaStatusList,
    showFilters,
  } = useTransactionHistoryContext();

  let statusArr = transactionStatusList;
  if (selectedTransType.value === "Letter of Authorization") {
    statusArr = loaStatusList;
  }

  let statusFilter = (
    <React.Fragment>
      <div className="flex items-center my-4">
        <p className="text-sm font-semibold shrink">Status</p>
        <div className="border-t grow mx-3"></div>
      </div>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="All"
          name="radio-buttons-group"
          value={selectedStatus.value}
          onChange={(e) => handleSelectStatus(e.target.value)}
        >
          <FormControlLabel
            value="All"
            sx={{
              ".MuiFormControlLabel-label": {
                fontSize: 14,
                fontWeight: "500",
              },
            }}
            control={
              <Radio
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 18,
                  },
                }}
              />
            }
            label="All"
          />
          {statusArr.map((tType) => (
            <FormControlLabel
              key={tType}
              sx={{
                ".MuiFormControlLabel-label": {
                  fontSize: 14,
                  fontWeight: "500",
                },
              }}
              value={tType}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                    },
                  }}
                />
              }
              label={tType}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </React.Fragment>
  );

  let filterFields = null;
  if (selectedTransType.value === "PCC Consultation") {
    filterFields = (
      <React.Fragment>
        {statusFilter}
        <div className="flex items-center my-4">
          <p className="text-sm font-semibold shrink">Specialization</p>
          <div className="border-t grow mx-3"></div>
        </div>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="All"
            name="radio-buttons-group"
            value={selectedSpecialization.value}
            onChange={(e) => handleSelectSpecialization(e.target.value)}
          >
            <FormControlLabel
              value="All"
              sx={{
                ".MuiFormControlLabel-label": {
                  fontSize: 14,
                  fontWeight: "500",
                },
              }}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                      ":disabled": true,
                    },
                  }}
                />
              }
              label="All"
            />
            {specializationList.map((tType) => (
              <FormControlLabel
                key={tType}
                sx={{
                  ".MuiFormControlLabel-label": {
                    fontSize: 14,
                    fontWeight: "500",
                    textTransform: "capitalize",
                  },
                }}
                value={tType}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 18,
                      },
                    }}
                  />
                }
                label={tType?.toLowerCase()}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </React.Fragment>
    );
  } else if (selectedTransType.value === "PCC Medical Test") {
    filterFields = (
      <React.Fragment>
        {statusFilter}
        <div className="flex items-center my-4">
          <p className="text-sm font-semibold shrink">Type of medical test</p>
          <div className="border-t grow mx-3"></div>
        </div>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="All"
            name="radio-buttons-group"
            value={selectedMedicalTestType.value}
            onChange={(e) => handleSelectMedicalTestType(e.target.value)}
          >
            <FormControlLabel
              value="All"
              sx={{
                ".MuiFormControlLabel-label": {
                  fontSize: 14,
                  fontWeight: "500",
                },
              }}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                    },
                  }}
                />
              }
              label="All"
            />
            {medicalTestTypeList.map((tType) => (
              <FormControlLabel
                key={tType}
                sx={{
                  ".MuiFormControlLabel-label": {
                    fontSize: 14,
                    fontWeight: "500",
                    textTransform: "capitalize",
                  },
                }}
                value={tType}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 18,
                      },
                    }}
                  />
                }
                label={tType?.toLowerCase()}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </React.Fragment>
    );
  } else if (selectedTransType.value === "Reimbursement") {
    filterFields = (
      <React.Fragment>
        {statusFilter}
        <div className="flex items-center my-4">
          <p className="text-sm font-semibold shrink">Claim type</p>
          <div className="border-t grow mx-3"></div>
        </div>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="All"
            name="radio-buttons-group"
            value={selectedClaimType.value}
            onChange={(e) => handleSelectClaimType(e.target.value)}
          >
            <FormControlLabel
              value="All"
              sx={{
                ".MuiFormControlLabel-label": {
                  fontSize: 14,
                  fontWeight: "500",
                },
              }}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                    },
                  }}
                />
              }
              label="All"
            />
            {claimTypeList.map((tType) => (
              <FormControlLabel
                key={tType}
                sx={{
                  ".MuiFormControlLabel-label": {
                    fontSize: 14,
                    fontWeight: "500",
                  },
                }}
                value={tType}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 18,
                      },
                    }}
                  />
                }
                label={tType}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </React.Fragment>
    );
  } else if (selectedTransType.value === "Letter of Authorization") {
    filterFields = (
      <React.Fragment>
        {statusFilter}
        <div className="flex items-center my-4">
          <p className="text-sm font-semibold shrink">Consultation type</p>
          <div className="border-t grow mx-3"></div>
        </div>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="All"
            name="radio-buttons-group"
            value={selectedConsultationType.value}
            onChange={(e) => handleSelectConsultationType(e.target.value)}
          >
            <FormControlLabel
              value="All"
              sx={{
                ".MuiFormControlLabel-label": {
                  fontSize: 14,
                  fontWeight: "500",
                },
              }}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                    },
                  }}
                />
              }
              label="All"
            />
            {consultationTypeList.map((tType) => (
              <FormControlLabel
                key={tType}
                sx={{
                  ".MuiFormControlLabel-label": {
                    fontSize: 14,
                    fontWeight: "500",
                  },
                }}
                value={tType}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 18,
                      },
                    }}
                  />
                }
                label={tType}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </React.Fragment>
    );
  }

  return (
    <Modal
      open={showFilters}
      onClose={handleCloseFilter}
      sx={{ outline: "none" }}
    >
      <div className="flex flex-col w-full max-w-[350px] h-full border bg-white ml-auto overflow-hidden">
        <div className="flex flex-row items-center p-4 border-b">
          <div className="text-center text-md font-bold flex-grow">Filters</div>
          <CloseOutlinedIcon
            className=" cursor-pointer"
            fontSize="small"
            onClick={handleCloseFilter}
          />
        </div>
        <div className="p-4 h-full max-h-[calc(100vh-120px)] overflow-auto">
          <div className="flex items-center mb-2">
            <p className="text-sm font-semibold shrink">Transaction type</p>
            <div className="border-t grow mx-3"></div>
          </div>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="All"
              name="radio-buttons-group"
              value={selectedTransType.value}
              onChange={(e) => {
                handleSelectTransType(e.target.value);
              }}
            >
              <FormControlLabel
                value="All"
                sx={{
                  ".MuiFormControlLabel-label": {
                    fontSize: 14,
                    fontWeight: "500",
                  },
                }}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 18,
                      },
                    }}
                  />
                }
                label="All"
              />
              {transactionTypes.map((tType) => (
                <FormControlLabel
                  disabled={["Reimbursement (Coming Soon)"].includes(tType)}
                  key={tType}
                  sx={{
                    ".MuiFormControlLabel-label": {
                      fontSize: 14,
                      fontWeight: "500",
                    },
                  }}
                  value={tType}
                  control={
                    <Radio
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                        },
                      }}
                    />
                  }
                  label={tType}
                />
              ))}
            </RadioGroup>
          </FormControl>
          {filterFields}
          <div className="flex items-center my-4">
            <p className="text-sm font-semibold shrink">Date range</p>
            <div className="border-t grow mx-3"></div>
          </div>
          <div className="flex gap-3 items-center justify-center w-full">
            <div className="w-full">
              <div className="text-sm text-gray-500">Date from</div>
              <div className="mt-1">
                <DatePicker
                  disablePast={false}
                  disableFuture={true}
                  value={
                    selectedDateRange.dateFrom
                      ? dayjs(selectedDateRange.dateFrom)
                      : null
                  }
                  onAccept={(newValue) => {
                    if (newValue !== null) {
                      handleChangeDateFrom(newValue);
                    }
                  }}
                />
              </div>
            </div>
            <div className="w-full">
              <div className="text-sm text-gray-500">Date to</div>
              <div className="mt-1">
                <DatePicker
                  disablePast={false}
                  disableFuture={true}
                  value={
                    selectedDateRange.dateTo
                      ? dayjs(selectedDateRange.dateTo)
                      : null
                  }
                  onAccept={(newValue) => {
                    if (newValue !== null) {
                      handleChangeDateTo(newValue);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex items-center my-4">
            <p className="text-sm font-semibold shrink">Nearby timeframe</p>
            <div className="border-t grow mx-3"></div>
          </div>
          <div className="flex gap-3 items-center justify-center w-full">
            <Button
              className={`w-full bg-white text-sm border
                            ${
                              selectedDateRange.timeFrame === 30
                                ? " border-blue-500"
                                : ""
                            }`}
              onClick={() => handleSelectTimeFrame(30)}
            >
              Recent 30 days
            </Button>
            <Button
              className={`w-full bg-white text-sm border
                            ${
                              selectedDateRange.timeFrame === 120
                                ? " border-blue-500"
                                : ""
                            }`}
              onClick={() => handleSelectTimeFrame(120)}
            >
              120 days
            </Button>
          </div>
        </div>
        <div className="p-3 flex gap-3 items-center justify-center lg:justify-end w-full shadow-[0px_-5px_15px_#e2e5ed]">
          <Button
            className="w-full lg:w-1/4 bg-white border"
            onClick={handleClearFilter}
          >
            Clear all
          </Button>
          <Button
            className="w-full lg:w-1/4 text-white"
            onClick={handleApplyFilter}
            disabled={!hasValidDateRange}
          >
            Apply
          </Button>
        </div>
      </div>
    </Modal>
  );
}
